import { useEffect, useState } from 'react';
import Select from 'react-select';
import { BaseSelector } from '../../../../models/baseSelector';
import { UserModel, UserModelAPI } from '../../../../models/users/UserModel';
import { AuditLogsFiltersValues } from '../../../../pages/audit-logs/components/AuditLogsFilters';
import { UserAPI } from '../../../../services/external/APIs/users/User.api';

interface Props {
  id: string;
  onChange: (next: AuditLogsFiltersValues) => void;
  value: string | null;
  label: string;
  disabled?: boolean;
  values: AuditLogsFiltersValues;
}

export const UserSelector = ({ id, disabled, onChange, value, label, values }: Props) => {
  const [dataList, setDataList] = useState<BaseSelector[]>([]);
  const [isLoadingData, setIsLoadingData] = useState(true);

  useEffect(() => {
    UserAPI.getUsers().then((response: UserModel[]) => {
      const convertedResponse = [
        {
          label: '-- Todos los usuarios --',
          value: 0,
        },
      ].concat(
        response.map((item: UserModelAPI) => {
          return {
            label: item.fullName,
            value: item.id,
          };
        }),
      );

      setDataList(convertedResponse);
    });

    setIsLoadingData(false);
  }, []);

  return (
    <>
      {label && label.trim() !== '' && <label>{label}:</label>}

      <div className="p-0 m-0">
        <Select
          id={id}
          key={id}
          name={id}
          options={dataList}
          isLoading={isLoadingData}
          className="text-dark p-0 m-0"
          isSearchable={true}
          isDisabled={disabled}
          placeholder={label ? label : 'Todos los usuarios'}
          onChange={(e) => {
            let newValue: string | null = e?.value ? e.value.toString() : null;
            onChange({ ...values, userId: newValue });
          }}
          value={
            value ? dataList.find((a) => a.value === value) : dataList.find((a) => a.value === 0)
          }
        />
      </div>
    </>
  );
};
